
export default {
    lackOfPax: 'Please select an nominee.',
    errorMessageTitle: 'an error occurred, please try again later.',
    loginErrorMessage: 'You are not authorized to access to Staff Portal.\nPlease reach HR if you have any concerns.',
    lackOfAdult: 'Infants (less than 2 years old) travelling without seats must be held by an adult. Please select an adult.',
    insufficientEntitlements: 'When choosing a round-trip ticket please make sure each passenger has sufficient entitlements.'
};